import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorTileId,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput/index.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import {
  selectTargetAccumulatorScheduleData,
  selectTargetAccumulatorScheduleFieldValidation,
  selectTargetAccumulatorScheduleTable,
} from '@/store/targetAccumulator/selectors.ts';
import type { AccumulatorScheduleLine } from '@/store/targetAccumulator/state.ts';

const EkiUp = ({ legId }: { legId: string }) => {
  const tileId = useTargetAccumulatorTileId();
  const ekiUp = useAppSelector((state) => selectTargetAccumulatorScheduleTable(state, tileId, legId)?.ekiUp);
  const isModified = useAppSelector(
    (state) =>
      selectTargetAccumulatorScheduleData(state, tileId).scheduleCustomFields?.[legId]?.includes('EkiUp') ?? false,
  );
  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();
  const { sgwtWebAnalytics } = useSgwtWidgets();
  const { validation } = useAppSelector((state) =>
    selectTargetAccumulatorScheduleFieldValidation(state, tileId, legId, 'stepUpString'),
  );

  const handleEkiUp = (value: number | undefined) => {
    sgwtWebAnalytics?.trackEvent(
      'Target Accumulator',
      'Schedule ekiUp changed',
      isDefined(value) ? String(value) : 'null',
    );

    return checkTargetAccumulatorWithTradeCapture({
      schedule: { [legId]: { ekiUp: isDefined(value) ? value : null } as AccumulatorScheduleLine },
    });
  };

  return (
    <div style={{ maxWidth: '5rem' }}>
      <TradeCaptureValidationWrapper validation={validation}>
        <SgNumberInput
          valuePosition="start"
          selectAllOnFocus
          className={isModified ? 'text-info' : ''}
          value={isDefined(ekiUp) ? ekiUp : undefined}
          maxDecimals={9}
          onChange={handleEkiUp}
          size="sm"
          data-e2e-is-modified={isModified}
          data-e2e="ekiUp"
        />
      </TradeCaptureValidationWrapper>
    </div>
  );
};

export default EkiUp;
